module.exports = __webpack_public_path__ + "img/55.2.TN.4a65287c.png";